import { CLIENT_DOCUMENT_ISSUED_BY } from '../../../../../constants';

export const FLOW_PRINT = 'print';
export const FLOW_ECP = 'ecp';
export const flowKey = (dealId) => `tripartite-flow-${dealId}`;

export const PERSON_FIELDS = [
  { key: 'surname', label: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ' },
  { key: 'name', label: 'ÐÐ¼Ñ' },
  { key: 'middlename', label: 'ÐÑÑÐµÑÑÐ²Ð¾' },
  { key: 'iin', label: 'ÐÐÐ' },
  { key: 'phone', label: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½', kind: 'phone', placeholder: '+7 (___) ___-__-__' },
  { key: 'documentNumber', label: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ â' },
  { key: 'documentDate', label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸', type: 'date' },
  { key: 'documentIssuer', label: 'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½', type: 'issuer' },
  { key: 'address', label: 'ÐÐ´ÑÐµÑ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸' },
];

export const CAR_FIELDS = [
  { key: 'issueYear', label: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°' },
  { key: 'vin', label: 'VIN / Ð½Ð¾Ð¼ÐµÑ ÐºÑÐ·Ð¾Ð²Ð°' },
  { key: 'grnz', label: 'ÐÐ¾ÑÐ½Ð¾Ð¼ÐµÑ (ÐÐ ÐÐ)' },
  { key: 'texNumber', label: 'Ð¡Ð Ð¢Ð¡ â' },
  { key: 'texDate', label: 'Ð¡Ð Ð¢Ð¡ Ð¾Ñ', type: 'date' },
  { key: 'color', label: 'Ð¦Ð²ÐµÑ' },
  { key: 'mileage', label: 'ÐÑÐ¾Ð±ÐµÐ³, ÐºÐ¼' },
];

export const REQUISITES_FIELDS = [
  { key: 'recipient', label: 'ÐÐ¾Ð»ÑÑÐ°ÑÐµÐ»Ñ' },
  { key: 'iban', label: 'IBAN', kind: 'iban', placeholder: 'KZ000000000000000000' },
  { key: 'bankName', label: 'ÐÐ°Ð½Ðº' },
  { key: 'bic', label: 'ÐÐÐ / BIC', kind: 'bic', placeholder: 'KCJBKZKX' },
];

const DATE_KEYS = ['documentDate', 'texDate'];

const toDateInput = (value) => (value ? String(value).slice(0, 10) : '');
const digits = (value) => String(value || '').replace(/\D/g, '');

export const normalizePhone = (value) => {
  let next = digits(value);
  if (next.startsWith('8') && next.length === 11) next = `7${next.slice(1)}`;
  return next.slice(0, 11);
};
export const validPhone = (value) => {
  const next = digits(value);
  return next.length === 11 && next.startsWith('7');
};
export const displayPhone = (value) => {
  const next = normalizePhone(value);
  if (!validPhone(next)) return String(value || '').trim();
  return `+7 (${next.slice(1, 4)}) ${next.slice(4, 7)}-${next.slice(7, 9)}-${next.slice(9, 11)}`;
};

// ÐÐ°Ð·Ð°ÑÑÑÐ°Ð½ Ñ 2024 Ð½Ð° Ð¾Ð´Ð½Ð¾Ð¼ Ð¿Ð¾ÑÑÐµ UTC+5. ÐÑÐº ÐºÐ»Ð°Ð´ÑÑ smsAt/signedAt ÐºÐ°Ðº UTC ISO.
export const KZ_TIME_ZONE = 'Asia/Almaty';
export const formatWhen = (iso) => {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('ru-RU', {
    timeZone: KZ_TIME_ZONE,
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
};
export const cleanIban = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20);
export const validIban = (value) => /^KZ[0-9A-Z]{18}$/.test(cleanIban(value));
export const cleanBic = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 11);
export const validBic = (value) => /^[A-Z]{8}([A-Z0-9]{3})?$/.test(cleanBic(value));
export const formatField = (kind, value) => {
  if (kind === 'phone') return normalizePhone(value);
  if (kind === 'iban') return cleanIban(value);
  if (kind === 'bic') return cleanBic(value);
  return value;
};

const emptyToNull = (obj) => {
  const next = { ...obj };
  DATE_KEYS.forEach((key) => {
    if (key in next && !next[key]) next[key] = null;
  });
  return next;
};

const personForm = (person) => ({
  surname: person?.surname || '',
  name: person?.name || '',
  middlename: person?.middlename || '',
  iin: person?.iin || '',
  phone: normalizePhone(person?.phone),
  documentNumber: person?.documentNumber || '',
  documentDate: toDateInput(person?.documentDate),
  documentIssuer: person?.documentIssuer || '',
  address: person?.address || '',
});

// ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â ÐÐ¦ (ÑÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ): Ð´Ð°Ð½Ð½ÑÐµ Ð±ÐµÑÑÑÑÑ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÐÐ¦ Ð¸ Ð½Ðµ Ð¿ÑÐ°Ð²ÑÑÑÑ, Ð² ÑÐ¾ÑÐ¼Ðµ Ð¾ÑÑÐ°ÑÑÑÑ
// ÑÐ¾Ð»ÑÐºÐ¾ ÑÐµÐ»ÐµÑÐ¾Ð½ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ° Ð´Ð»Ñ Ð­Ð¦Ð.
export const isDcSeller = (values) => values?.seller?.type === 'dc';

export const formFromValues = (values, parties) => {
  const seller = isDcSeller(values) ? { phone: normalizePhone(values.seller.phone) } : personForm(values?.seller);
  return {
    seller,
    buyer: personForm(values?.buyer),
    car: {
      issueYear: values?.car?.issueYear || '',
      vin: values?.car?.vin || '',
      grnz: values?.car?.grnz || '',
      texNumber: values?.car?.texNumber || '',
      texDate: toDateInput(values?.car?.texDate),
      color: values?.car?.color || '',
      mileage: values?.car?.mileage || '',
    },
    requisites: {
      recipient:
        values?.requisites?.recipient ||
        [seller.surname, seller.name, seller.middlename].filter(Boolean).join(' '),
      iban: cleanIban(values?.requisites?.iban),
      bankName: values?.requisites?.bankName || '',
      bic: cleanBic(values?.requisites?.bic),
    },
    agent: {
      director: values?.agent?.director || '',
      basis: values?.agent?.basis || 'Ð£ÑÑÐ°Ð²Ð°',
      phone: normalizePhone(values?.agent?.phone || parties?.agent?.phone),
    },
    terms: {
      agentFee: String(values?.agentFee || 1000),
      payoutDays: String(values?.payoutDays || 3),
      handoverDays: String(values?.handoverDays || 3),
      defects: values?.defects || '',
      keysCount: values?.keysCount ? String(values.keysCount) : '',
      extraEquipment: values?.extraEquipment || '',
    },
    price: values?.price || '',
  };
};

export const issuerOption = (raw) => {
  const byValue = CLIENT_DOCUMENT_ISSUED_BY.find((item) => String(item.value) === String(raw));
  if (byValue) return byValue;
  const text = String(raw || '').toLowerCase();
  if (text.includes('Ð¼Ñ') || text.includes('ÑÑÑÐ¸Ñ')) return CLIENT_DOCUMENT_ISSUED_BY[1];
  if (text.includes('Ð¼Ð²Ð´') || text === '1') return CLIENT_DOCUMENT_ISSUED_BY[0];
  return null;
};

export const personName = (p) => [p?.surname, p?.name, p?.middlename].filter(Boolean).join(' ');

export const ecpSmsPhone = (form, role) =>
  normalizePhone(role === 'agent' ? form?.agent?.phone : form?.[role]?.phone);

export const fieldDomId = (path) => `tripartite-${String(path).replace(/\./g, '-')}`;

export const focusFirstError = (paths) => {
  const path = (paths || []).find(Boolean);
  if (!path || typeof document === 'undefined') return;
  const root = document.getElementById(fieldDomId(path));
  if (!root) return;
  const target =
    root.matches?.('input, textarea, select')
      ? root
      : root.querySelector('input, textarea, select, [tabindex]:not([tabindex="-1"])');
  const el = target || root;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.focus?.({ preventScroll: true });
};

export const formErrors = (form, missingFromServer, flow) => {
  const missing = (missingFromServer || []).filter((path) => {
    const [section, key] = path.split('.');
    if (!form) return true;
    if (!key) return section === 'price' ? !form.price : true;
    return !String(form?.[section]?.[key] || '').trim();
  });
  const invalid = [];
  if (form) {
    [
      ['seller.phone', form.seller?.phone, flow === FLOW_ECP],
      ['buyer.phone', form.buyer?.phone, flow === FLOW_ECP],
      ['agent.phone', form.agent?.phone, flow === FLOW_ECP],
    ].forEach(([path, value, required]) => {
      const filled = String(value || '').trim();
      if (!filled) {
        if (required) invalid.push(path);
        return;
      }
      if (!validPhone(value)) invalid.push(path);
    });
    if (form.requisites?.iban && !validIban(form.requisites.iban)) invalid.push('requisites.iban');
    if (form.requisites?.bic && !validBic(form.requisites.bic)) invalid.push('requisites.bic');
    // ÐÐ¾Ð·Ð½Ð°Ð³ÑÐ°Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ´ÐµÑÐ¶Ð¸Ð²Ð°ÑÑ Ð¸Ð· Ð²ÑÐ¿Ð»Ð°ÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÑ: Ð¿ÑÑÑÐ¾Ðµ Ð¿Ð¾Ð»Ðµ Ð±ÑÐº Ð¼Ð¾Ð»ÑÐ°
    // Ð¿ÑÐ¾Ð¸Ð³Ð½Ð¾ÑÐ¸ÑÐ¾Ð²Ð°Ð» Ð±Ñ Ð¸ Ð½Ð°Ð¿ÐµÑÐ°ÑÐ°Ð» Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¿ÑÐµÐ¶Ð½ÑÑ ÑÑÐ¼Ð¼Ñ.
    if (!(Number(form.terms?.agentFee) > 0)) invalid.push('terms.agentFee');
  }
  const blocked = [...missing, ...invalid];
  return {
    missing,
    invalid,
    blocked,
    isError: (section, key) => blocked.includes(section) || blocked.includes(`${section}.${key}`),
  };
};

export const savePayload = (dealId, form, extra = {}) => ({
  dealId,
  seller: emptyToNull(form.seller),
  buyer: emptyToNull(form.buyer),
  car: emptyToNull(form.car),
  requisites: form.requisites,
  agent: form.agent,
  terms: {
    agentFee: Number(form.terms.agentFee) || 0,
    payoutDays: Number(form.terms.payoutDays) || 3,
    handoverDays: Number(form.terms.handoverDays) || 3,
    defects: form.terms.defects,
    keysCount: Number(form.terms.keysCount) || 0,
    extraEquipment: form.terms.extraEquipment,
  },
  price: Number(form?.price) || 0,
  confirmWipe: Boolean(extra.confirmWipe),
});

const ecpBusy = (ecp) => {
  const signed = Number(ecp?.signedCount) || 0;
  if (signed > 0 || ecp?.stage === 'complete' || ecp?.stage === 'waiting') return true;
  return (ecp?.signers || []).some((s) => s.status === 'sms' || s.status === 'signed');
};

export const regenerateWarning = (ecp, hasFile) => {
  if (!hasFile) return '';
  const signed = Number(ecp?.signedCount) || 0;
  if (ecp?.stage === 'complete' || signed >= 3) {
    return 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½ 3 ÑÑÐ¾ÑÐ¾Ð½Ð°Ð¼Ð¸. ÐÐ¾Ð²ÑÐ¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð°Ð½Ð½ÑÐ»Ð¸ÑÑÐµÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸ Ð¸ Ð¿ÑÐ¾ÑÐµÑÑ Ð½Ð°ÑÐ½ÑÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.';
  }
  if (signed > 0) {
    return signed === 1
      ? 'ÐÑÑÑ 1 Ð¿Ð¾Ð´Ð¿Ð¸ÑÑ. ÐÑÐ¾ÑÐµÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð½Ð°ÑÐ½ÑÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.'
      : `ÐÑÑÑ ${signed} Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ¸. ÐÑÐ¾ÑÐµÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð½Ð°ÑÐ½ÑÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.`;
  }
  if (ecpBusy(ecp)) {
    return 'Ð¡ÐÐ¡ ÑÐ¶Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð°. ÐÑÐ¾ÑÐµÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð½Ð°ÑÐ½ÑÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.';
  }
  return 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð±ÑÐ´ÐµÑ Ð·Ð°Ð¼ÐµÐ½ÑÐ½.';
};

export const restartEcpWarning = (ecp) => {
  const signed = Number(ecp?.signedCount) || 0;
  if (signed > 0 || ecp?.stage === 'complete') {
    return 'ÐÐ¾Ð´Ð¿Ð¸ÑÐ¸ Ð±ÑÐ´ÑÑ ÑÐ±ÑÐ¾ÑÐµÐ½Ñ.';
  }
  return 'ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð½Ð°ÑÐ½ÑÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾.';
};

export const switchFlowWarning = (ecp) => {
  if (!ecpBusy(ecp)) return '';
  const signed = Number(ecp?.signedCount) || 0;
  if (signed > 0) return 'ÐÐ¾Ð³Ð¾Ð²Ð¾Ñ ÑÐ°ÑÑÐ¸ÑÐ½Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½ Ð­Ð¦Ð.';
  return 'ÐÐ´ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð­Ð¦Ð.';
};

export const canGoNext = ({ flow, hasFile, ecp, nextStep }) => {
  if (!nextStep || !hasFile) return false;
  if (flow === FLOW_ECP) return ecp?.stage === 'complete';
  return true;
};
